import { render } from "./pane.vue?vue&type=template&id=696334ce&scoped=true"
import script from "./pane.vue?vue&type=script&lang=js"
export * from "./pane.vue?vue&type=script&lang=js"

import "./pane.vue?vue&type=style&index=0&id=696334ce&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696334ce"]])

export default __exports__